import { BaseSelectBoxDataBind } from "./selectbox-base";

/** 
 * Data bind for <select> selected option. 
 */
export class SelectElementDataBind extends BaseSelectBoxDataBind
{
    public attributeName = 'data-bind-select';
    public selector = '[data-bind-select]';
    public eventNames = ['change'];

    protected setElementValue(element: HTMLSelectElement, value: any)
    {
        element.selectedIndex = 0;

        let values = this.parseOptions(value);
        let multiple = element.multiple;

        for(let i = 0; i < element.options.length; i++)
        {
            let option = element.options[i] as HTMLOptionElement;

            if (values.indexOf(option.value) > -1)
            {
                option.selected = true;

                if (!multiple)
                {
                    break;
                }
            }
            else
            {
                option.selected = false;
            }
        }
    }

    /**
     * Returns the selected options of the select element.
     * Returns an array of strings if multiple is enabled. Returns string or undefined otherwise.
     * @param element The select element.
     */
    protected getElementValue(element: HTMLSelectElement): any
    {
        let result: string[] = [];
        let multiple = element.multiple;
        
        for(let i = 0; i < element.options.length; i++)
        {
            let option = element.options[i] as HTMLOptionElement;
            if (option.selected)
            {
                result.push(option.value);

                if (!multiple)
                {
                    break;
                }
            }
        }

        return multiple ? result : (result.length > 0 ? result[0] : undefined);
    }
}